import React, { Component } from 'react'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import SiteVars from '~/Classes/siteVars'

class TemplateImageLoader extends Component {
    constructor(props) {
        super(props)
        this.timer
        this.unmouting = false
        this.state = {
            templateImageLoaded: false,
            rndNo: Date.now(),
            loadTries: 0
        }
        this.checkTemplateImageExists = this.checkTemplateImageExists.bind(this)
    }

    componentWillUnmount() {
        this.unmouting = true
        clearTimeout(this.timer)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.imageUrl !== this.props.imageUrl) {
            clearTimeout(this.timer)
            this.setState(
                {
                    templateImageLoaded: false,
                    rndNo: Date.now(),
                    loadTries: 0
                },
                this.checkTemplateImageExists
            )
        }
    }

    checkTemplateImageExists() {
        if (this.state.templateImageLoaded) return
        if (this.unmouting) return
        if (this.state.loadTries > 60) {
            return
        }
        var loadTries = this.state.loadTries + 1
        this.setState({ loadTries })
        var self = this
        var img = new Image()
        var cacheBust = Date.now()
        img.onload = function () {
            self.setState({ templateImageLoaded: true, rndNo: cacheBust })
        }
        img.onerror = function () {
            if (!self.unmouting) {
                self.timer = setTimeout(self.checkTemplateImageExists, 2000)
            }
        }
        img.src = this.props.imageUrl + '?v=' + cacheBust
    }

    componentDidMount() {
        this.checkTemplateImageExists()
    }

    render() {
        var imageUrl = this.props.imageUrl + '?rnd=' + this.state.rndNo
        var backgroundImage = 'url(' + imageUrl + ')'

        if (this.state.loadTries > 60) {
            backgroundImage = `url(${SiteVars.repoEndPoint}siteContent/assets/templates/common/unknownTemplate.jpg)`
            return <div className='templateImageImg' style={{ backgroundImage: backgroundImage }} />
        }

        if (this.state.templateImageLoaded) {
            let className = 'templateImageImg'
            if (this.props.type === 6) {
                className += ' phone'
            }
            if (this.props.form) {
                className += ' form'
            }
            return (
                <div
                    className={className}
                    style={{ backgroundImage: backgroundImage, cursor: this.props.onClick ? 'pointer' : '' }}
                    onClick={this.props.onClick}
                />
            )
        } else {
            return <LoadingIcons iconType='2' />
        }
    }
}

export default TemplateImageLoader
